module.exports = ".card .card-header .card-header-right .card-option {\n  width: 140px;\n  transition: unset; }\n"